import { Link } from "react-router-dom";
import { LogoMark } from "@/components/Logo";
import { CONTACT } from "@/lib/api";
import { SERVICE_PAGES } from "@/lib/servicePages";

const EXPLORE = [["services", "Services"], ["packages", "Packages"], ["pricing", "Pricing"], ["portfolio", "Portfolio"], ["about", "About us"], ["faq", "FAQs"], ["contact", "Contact"]];

export const Footer = () => (
  <footer className="relative overflow-hidden border-t border-white/10 pt-16 pb-8" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
      <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <LogoMark size={40} animated />
          <p className="mt-4 max-w-xs text-sm text-slate-300">{CONTACT.company} — websites, local SEO, AEO and AI automation for growing businesses in Pune.</p>
        </div>
        <nav className="text-sm text-slate-300" aria-label="Footer">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-slate-400">Explore</p>
          {EXPLORE.map(([id, label]) => (
            <Link key={id} to="/" state={{ to: id }} data-testid={`footer-link-${id}`} className="mt-3 block hover:text-[#00F0FF]">{label}</Link>
          ))}
        </nav>
        <nav className="text-sm text-slate-300" aria-label="Services">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-slate-400">Services</p>
          {SERVICE_PAGES.map((p) => (
            <Link key={p.slug} to={`/services/${p.slug}`} data-testid={`footer-service-${p.slug}`} className="mt-3 block hover:text-[#00F0FF]">{p.name}</Link>
          ))}
        </nav>
        <div className="text-sm text-slate-300">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-slate-400">Reach us</p>
          <p className="mt-3" data-testid="footer-founder">Founder: {CONTACT.founder}</p>
          <a href={CONTACT.phoneHref} className="mt-3 block hover:text-[#00F0FF]" data-testid="footer-phone">Mobile / Helpline: +91 {CONTACT.phone}</a>
          <a href={CONTACT.mailHref} className="mt-3 block break-all hover:text-[#00F0FF]" data-testid="footer-email">{CONTACT.email}</a>
          <p className="mt-3" data-testid="footer-location">{CONTACT.location}</p>
        </div>
      </div>
      <p className="mt-16 select-none font-display text-[11.5vw] font-extrabold leading-[0.8] tracking-tighter text-white/[0.04] lg:text-[9rem]" aria-hidden="true">swayamscale</p>
      <div className="mt-6 flex flex-col justify-between gap-3 border-t border-white/10 pt-6 text-xs text-slate-400 sm:flex-row">
        <span>© 2026 {CONTACT.company}. All rights reserved.</span>
        <span className="flex gap-5">
          <Link to="/privacy-policy" className="hover:text-white" data-testid="footer-privacy-link">Privacy Policy</Link>
          <Link to="/terms-and-conditions" className="hover:text-white" data-testid="footer-terms-link">Terms and Conditions</Link>
        </span>
      </div>
    </div>
  </footer>
);
